import { Create, TextInput, required, SimpleForm, SelectInput, ReferenceInput } from 'react-admin';
import { BATCH_TEMPLATE_TYPE, STATUSES } from '../../common/constants';
import HTMLEditorInput, { validHtml } from '../../common/inputs/HTMLEditorInput';
import SlugInput from '../../common/inputs/SlugInput';
import { ProgramAutocomplete } from '../../common/inputs/autoCompleteInputs/ProgramAutoComplete';

const BatchTemplateCreate = () => (
    <Create redirect={'/batch-templates'}>
        <SimpleForm>
            <TextInput source="title" fullWidth validate={[required()]} />
            <SlugInput source="slug" fullWidth />
            <SelectInput
                source="status"
                label={'Status'}
                fullWidth
                validate={[required()]}
                choices={STATUSES}
            />
            <SelectInput
                source="type"
                label={'Type'}
                fullWidth
                validate={[required()]}
                choices={BATCH_TEMPLATE_TYPE}
            />
            <ProgramAutocomplete validate={[required()]} />
            <HTMLEditorInput source={'description'} fullWidth validate={[required(), validHtml]} />
        </SimpleForm>
    </Create>
);

export default BatchTemplateCreate;
